import type { Terms } from "@busbud/busbud-terms";

export interface SimplifiedTerms {
  content: string;
  icon?: string;
}

export default function getSimplifiedTerms(
  section: Terms
): Array<SimplifiedTerms> {
  if (section.subsections) {
    let flattened_terms: SimplifiedTerms[] = [];
    section.subsections.forEach(subsection => {
      const subsection_terms = getSimplifiedTerms(subsection);
      flattened_terms = flattened_terms.concat(subsection_terms);
    });
    return flattened_terms;
  }

  if (section.content) {
    const contents = Array.isArray(section.content)
      ? [...section.content]
      : [section.content];

    return contents.reduce<SimplifiedTerms[]>(
      (flattenTerms, content, index) => {
        if (content && content !== "") {
          const simplified_term: SimplifiedTerms = { content };

          if (section.icons && section.icons[index]) {
            simplified_term.icon = section.icons[index];
          }

          flattenTerms.push(simplified_term);
        }
        return flattenTerms;
      },
      []
    );
  }

  return [];
}
